import { usePageTranslator } from '../hooks/usePageTranslator';

/**
 * Renders nothing. Mount it once, inside <LanguageProvider>, so the page translator runs for
 * the whole app (including modals and other portals, because it watches document.body).
 */
const TranslationManager = () => {
    usePageTranslator();
    return null;
};

export default TranslationManager;
